/*
 * @Description: React组件错误边界处理 frok from https://github.com/iamhefang/react-catchable
 * @Author: zhongshanxian01
 * @Date: 2021-05-23 13:52:57
 * @LastEditors: zhongshanxian01
 * @LastEditTime: 2022-01-05 15:01:13
 */

/*
```
import { catchable, ErrorBoundary } from "@components/catchable";

class XXXComponent extends React.Component{
    render(){
        return <HELLO />
    }
}

export default catchable(XXXComponent);

or

export class XXXComponent extends React.Component{
    render(){
        return (
            <ErrorBoundary>
                <HELLO />
            </ErrorBoundary>
        )
    }
}
```
*/

import React from 'react';
import ReactDOM from 'react-dom';
import catchreacterror from 'catch-react-error';
import { isBrowser } from '@config/env';
import baseInfo from '@stores/index.js';
import WinBox from '@components/winBox';
import * as Sentry from '@sentry/react';
import logger from '@server-utils/client-logger';

const WinContent = () => {
    return (
        <React.Fragment>
            <p className="rule-item">组件渲染异常, 是否重新刷新页面?</p>
            <a
                className="btn"
                onClick={() => {
                    location.reload();
                }}
            >
                确定
            </a>
        </React.Fragment>
    );
};

export interface State {
    error?: any;
    errorInfo?: any;
    crashed: boolean;
}

export function catchable(WrappedComponent: any) {
    // 捕获SSR异常
    return catchreacterror(ErrorBoundary)(WrappedComponent);
    // return class Catchable extends ErrorBoundary {
    //     constructor(props: any) {
    //         super(props);
    //         this.state = {
    //             crashed: false
    //         };
    //     }
    //     componentDidCatch(err: any, errInfo: any) {
    //         super.componentDidCatch(err, errInfo);
    //     }
    //     render() {
    //         const { crashed } = this.state;
    //         return crashed ? null : <WrappedComponent {...this.props} />;
    //     }
    // };
}

export class ErrorBoundary extends React.Component<any, State> {
    constructor(props: any) {
        super(props);
        this.state = {
            error: null,
            errorInfo: null,
            crashed: false
        };
    }

    componentDidCatch(err: any, errorInfo: any) {
        this.setState({
            error: err,
            errorInfo,
            crashed: true
        });
        // 打印错误日志，服务端可以监控到
        const errorString = '组件渲染异常 from Error Boundaries' + err.stack;
        logger.error({
            messgae: `${errorString}`,
            paddingMessage: 'error catch by ErrorBoundary'
        });
        Sentry.captureException(err);
        // 浏览器上报日志
        if (isBrowser) this.showErrorTip();
    }

    // 浏览器中弹出提示框
    showErrorTip = () => {
        const container = document.createElement('div');
        document.body.appendChild(container);
        baseInfo.setData('showMask', true);
        ReactDOM.render(
            <WinBox
                customClass="error-boundary"
                visible={true}
                contentSlot={<WinContent />}
                handleClose={() => {
                    this.umMount(container);
                    baseInfo.setData('showMask', false);
                }}
            />,
            container
        );
    };

    umMount = (container: any) => {
        ReactDOM.unmountComponentAtNode(container);
        container.parentNode && container.parentNode.removeChild(container);
    };

    render() {
        const { crashed } = this.state;
        return crashed ? null : this.props.children;
    }
}
